import { FC } from "react"
import "./PartnersNet.less"

import WebsiteButton from "@/components/website-button/WebsiteButton"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { websiteRoutes } from "@/router/routes"
import { Col, Row, Skeleton } from "antd"
import { useNavigate } from "react-router-dom"
import bgImg from "./images/partners-bg-img.webp"

const { Title, Paragraph } = WebsiteTypography

export type PartnerItem = {
  id: string
  url: string
}

type PartnersNetProps = {
  title: {
    bold: string
    regular: string
  }
  items: PartnerItem[]
  loading: boolean
  isButton?: boolean
}

const PartnersNet: FC<PartnersNetProps> = ({ items, title, loading, isButton = false }) => {
  const navigate = useNavigate()
  const { website } = websiteRoutes

  const onFindOutMoreClick = () => {
    navigate(`/easetech${website.home}`)
  }
  // const urls = data
  //   .map((org) => org.attributes?.logoWithCompanyName?.data?.attributes?.url || null)
  //   .filter((url): url is string => !!url)

  return (
    <div className={"partner-net-wrapper"}>
      <div className={"net-bg-img"}>
        <img src={bgImg} alt={"background illustration"} />
      </div>

      <div className={"container"}>
        <Row justify={"center"}>
          <Title level={2} centered>
            <span className={"bold"}>
              <>
                {title.bold} {"\n"}
              </>
            </span>
            <span className={"w300"}>{title.regular}</span>
          </Title>
        </Row>

        <div className={"logos-grid-container"}>
          {loading
            ? new Array(4).fill(1)?.map((_, index) => (
                <div className={"partner-logo-container"} key={index}>
                  <Skeleton paragraph={{ rows: 2 }} active />
                </div>
              ))
            : items.map((it, index) => (
                <div className={"partner-logo-container"} key={it.id ?? index}>
                  <img src={it.url} alt={`Partner logo ${index + 1}`} />
                </div>
              ))}
        </div>

        <Row justify={"center"} style={{ paddingTop: 24 }}>
          <Paragraph size={"lg"} centered>
            {"and more..."}
          </Paragraph>
        </Row>

        {isButton && (
          <Row justify={"center"} style={{ paddingTop: 40 }}>
            <Col xxl={5} xl={5} lg={5} md={6} sm={12} xs={24}>
              <WebsiteButton btnType={"primary"} size={"large"} onClick={onFindOutMoreClick} block>
                {"FIND OUT MORE"}
              </WebsiteButton>
            </Col>
          </Row>
        )}
      </div>
    </div>
  )
}

export default PartnersNet
